/* oxlint-disable react/forbid-elements -- Original slider arrow SVGs from the approved Webflow export. */
import { values } from '../../../content/career/cards';
import * as React from 'react';
import { cx } from '../../../components/CareerLayout/styles';
import { CareerSlider } from '../../../components/CareerLayout/CareerSlider';

export const Values: React.FC = () => (
  <section className={cx('main_section_drive')}>
    <div className={cx('padding-global padding-section-medium')}>
      <div className={cx('container-large')}>
        <div className={cx('main_content_drive')}>
          <h2>
            {'вот что нами '}
            <span className={cx('text-color-brand-green')}>{'движет'}</span>
          </h2>
          <div className={cx('spacer-large')}></div>
          <CareerSlider>
            {({ previous, next }) =>
              values.map((value, index) => (
                <div key={value.title} className={cx('main_drive_slide')}>
                  <div className={cx('main_drive_slider-card')}>
                    <div className={cx('main_drive_card-left')}>
                      <div className={cx('main_drive_card-top')}>
                        <div className={cx('tag is-orange')}>
                          {index + 1}/{values.length}
                        </div>
                        <h3 className={cx('text-size-huge multiline')}>{value.title}</h3>
                      </div>
                      <div className={cx('main_drive_card-bottom')}>
                        <div className={cx('multiline')}>{value.description}</div>
                        <div className={cx('button-group is-main-drive-slider')}>
                          <button
                            type="button"
                            className={cx('main_drive_slider-button is-left')}
                            data-career-slider-direction="previous"
                            aria-label="Предыдущая ценность"
                            onClick={previous}
                          >
                            <svg viewBox="0 0 32 26" fill="none" className={cx('icon-1x1-small')} aria-hidden="true">
                              <path
                                d="M0 12.57L29.65 12.55M18.35 24.22L30 12.55L18.35.88"
                                stroke="currentColor"
                                strokeWidth="2.5"
                              />
                            </svg>
                          </button>
                          <button
                            type="button"
                            className={cx('main_drive_slider-button')}
                            data-career-slider-direction="next"
                            aria-label="Следующая ценность"
                            onClick={next}
                          >
                            <svg viewBox="0 0 32 26" fill="none" className={cx('icon-1x1-small')} aria-hidden="true">
                              <path
                                d="M0 12.57L29.65 12.55M18.35 24.22L30 12.55L18.35.88"
                                stroke="currentColor"
                                strokeWidth="2.5"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>
                    <img
                      src={value.image}
                      srcSet={value.srcSet}
                      sizes="(max-width: 767px) 100vw, 50vw"
                      loading="lazy"
                      alt=""
                      className={cx('main_drive_slider-image')}
                    />
                  </div>
                </div>
              ))
            }
          </CareerSlider>
        </div>
      </div>
    </div>
  </section>
);
